// extracted by mini-css-extract-plugin
module.exports = {"listItem":"followListItem_listItem__3z6aG","item":"followListItem_item__vGz8i","more":"followListItem_more__D930n"};